import { useContext } from "react";

import { Box } from "@/components/layout/flexbox";
import { PageSizeContext } from "@/components/layout/PageSize";

export function BottomActionContainer({
  position = "fixed",
  visible = true,
  backgroundGradient = "linear-gradient(rgba(255, 255, 255, 0),rgba(255, 255, 255, 0.2),rgba(255, 255, 255, 0.7),rgba(255, 255, 255, 0.95),rgba(255, 255, 255, 0.99),rgba(255, 255, 255, 0.99),rgba(255, 255, 255, 0.99),rgba(255, 255, 255, 0.99),rgba(255, 255, 255, 0.99),rgba(255, 255, 255, 1))",
  transitionSpeed = "0.4s",
  ...props
}) {
  const { isFullSize } = useContext(PageSizeContext);

  return (
    <Box
      px={3}
      {...props}
      style={{
        position,
        bottom: 0,
        left: 0,
        right: 0,
        background: backgroundGradient,
        paddingBottom: isFullSize ? 80 : 30,
        paddingTop: isFullSize ? 80 : 60,
        zIndex: 800,
        transition: visible
          ? `transform ${transitionSpeed}`
          : `transform 0.4s, visibility 0s ${transitionSpeed}`,
        transform: visible ? "translateY(0%)" : "translateY(100%)",
        visibility: visible ? "visible" : "hidden",
        ...props.style,
      }}
    />
  );
}
